var pagination = {
	backwardText: "الصفحة السابقة",
	forwardText: "الصفحة التالية",
	pageRangeText: "صفحة {current} من {total}",
	itemsPerPageText: "العناصر لكل صفحة",
	itemRangeText: "{start}-{end} من {total} عناصر",
	pageNumberText: "الصفحة الحالية"
};
var arTranslations = {
	pagination: pagination
};

export { arTranslations as default, pagination };
